export default "__VITE_ASSET__ELOpctt3__"